import $ from 'jquery';
import 'select2';

function initFolderMaterialsSelect() {
  $('.folder-materials-select, #design_folder_material_ids').each(function () {
    var $select = $(this);
    if ($select.hasClass('select2-hidden-accessible')) return;

    $select.select2({
      placeholder: $select.data('placeholder') || 'Start typing to search materials...',
      width: '100%',
      closeOnSelect: false
    });
  });
}

$(document).on('ready turbolinks:load', function () {
  initFolderMaterialsSelect();

  $('#user_company_id,.site-select').select2();

  $('.smart_search').select2({
    ajax: {
      url: 'users/smart_search',
      dataType: 'json',
      data: function (params) {
        var query = {
          'q[attribute]': $('#q_attribute').val(),
          'q[p]': $('#q_p').val(),
          'q[value]': params.term
        }
        return query;
      },
      processResults: function (data) {
        return {
          results: data
        };
      },
    },
    placeholder: $(this).attr('data-placeholder'),
    minimumInputLength: 1,
  });
});
